import { ActionTypes } from '../Actions/Actions';
import * as fromActions from '../Actions/Actions';

export interface IStateSound {
    music: boolean;
    soundFx: boolean;
}

export const defaultStateSound: IStateSound = {
    music: true,
    soundFx: true,
};
export const StateSound = (state = defaultStateSound, action: fromActions.Actions): IStateSound => {
    switch (action.type) {
        case ActionTypes.TOGGLE_SOUND:
            return {
                ...state,
                soundFx: action.payload,
            };
        case ActionTypes.TOGGLE_MUSIC:
            return {
                ...state,
                music: action.payload,
            };
        default:
            return state;
    }
};
